export default "__VITE_ASSET__hSl8XVxG__"